export default {
  SET_CLIENT_USERS: 'SET_CLIENT_USERS'
};
